import React, { useEffect, useState } from 'react';
import './App.css';
import PrivacyPolicy from './PrivacyPolicy';
import videoBg from './BLR_Pilot_Kepler.mp4';

const capabilities = [
  {
    icon: '🚦',
    title: 'Traffic Control & Challans',
    description:
      'AI-powered monitoring of traffic flow and automated issuance of violation challans using computer vision, reducing manual intervention and improving compliance.',
  },
  // {
  //   icon: '🏠',
  //   title: 'Property Tax Deviation',
  //   description:
  //     'Detect under-reported and incorrectly assessed properties through satellite and street-level imagery analysis, recovering lost revenue for municipalities.',
  // },
  // {
  //   icon: '🏪',
  //   title: 'Trade License Tax Deviation',
  //   description:
  //     'Identify unregistered or improperly classified commercial establishments and bring them into the tax net with minimal field visits.',
  // },
  {
    icon: '💰',
    title: 'Revenue Augmentation',
    description:
      "Plug revenue leakage and convert the city's existing tax base into realised revenue. The city's own assets generate revenue for the city.",
  },
  {
    icon: '🛣️',
    title: 'Road Infrastructure Management',
    description:
      'Continuously assess road quality, detect potholes and damaged signage, and prioritise maintenance schedules using continuous sensor and visual data.',
  },
  {
    icon: '♻️',
    title: 'Solid Waste Management',
    description:
      'Monitor waste collection routes, detect illegal dumping sites, and optimise fleet deployment to improve sanitation across urban zones.',
  },
  {
    icon: '🌿',
    title: 'Green Cover Monitoring',
    description:
      'Track urban tree canopy and green space changes over time, supporting compliance with urban greening policies and climate action plans.',
  },
  {
    icon: '💨',
    title: 'Pollution Monitoring',
    description:
      'Combine satellite imagery and ground surveys with arrays of sensors, converged with geospatial intelligence, to collect last-mile data — delivering continuous air quality indices and identifying pollution hotspots.',
  },
];

const steps = [
  { number: '01', title: 'Sense', description: 'Deploy arrays of sensors, converged with geospatial intelligence, to collect last-mile data across the city.' },
  { number: '02', title: 'Analyse', description: 'Process and enrich raw data with our AI copilot to surface actionable insights, anomalies, and deviations continuously.' },
  { number: '03', title: 'Act', description: 'Equip government bodies with dashboards, automated workflows, and recommendations so they can make faster and better-informed decisions.' },
];

const socials = [
  { label: 'Chitragupta Urban Tech (Company)', href: 'https://www.linkedin.com/company/chitragupta-urban-tech/home/' },
  { label: 'Naman Paithankar (Co-Founder and CEO)', href: 'https://www.linkedin.com/in/namanpaithankar/' },
  { label: 'Jayesh Golatkar (Co-Founder and CTO)', href: 'https://www.linkedin.com/in/jayeshgolatkar/' },
];

const PRIVACY_PATH = '/privacy-policy';

function isPrivacyPath(pathname) {
  return pathname.replace(/\/+$/, '') === PRIVACY_PATH;
}

function CGLogo({ className = '', title = 'Chitragupta logo' }) {
  return (
    <img
      className={`CGlogo-mark ${className}`.trim()}
      src={`${process.env.PUBLIC_URL}/CGlogo.jpg`}
      alt={title}
    />
  );
}

function App() {
  const onPrivacyPage = isPrivacyPath(window.location.pathname);
  const sectionHref = (id) => (onPrivacyPage ? `/#${id}` : `#${id}`);
  const [menuOpen, setMenuOpen] = useState(false);
  const [status, setStatus] = useState('idle'); // idle | sending | success | error
  const [source, setSource] = useState('contact');

  useEffect(() => {
    if (onPrivacyPage || !window.location.hash) return;
    const target = document.getElementById(window.location.hash.slice(1));
    if (target) target.scrollIntoView();
  }, [onPrivacyPage]);

  const goToContact = (enquirySource) => {
    setSource(enquirySource);
    setMenuOpen(false);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const form = e.target;
    setStatus('sending');
    try {
      await fetch(
        'https://script.google.com/macros/s/AKfycbwYCfBOlSsrn_T7_iTpglqHWC6SvF1M7nsdLzTYH3PPMLNWt5wNK-TeiPqsHbYuVee-/exec',
        {
          method: 'POST',
          mode: 'no-cors',
          body: new URLSearchParams(new FormData(form)),
        }
      );
      setStatus('success');
      form.reset();
      setSource('contact');
    } catch {
      setStatus('error');
    }
  };

  return (
    <div>
      {/* Header */}
      <header>
        <div className="container header-container">
          <a className="logo-wrap" href={onPrivacyPage ? '/' : '#hero'}>
            <CGLogo className="logo-icon" />
            <span className="logo">Chitragupta</span>
          </a>
          <button
            className="menu-toggle"
            aria-label="Toggle navigation"
            onClick={() => setMenuOpen((o) => !o)}
          >
            {menuOpen ? '✕' : '☰'}
          </button>
          <nav className={menuOpen ? 'nav-open' : ''}>
            <a href={sectionHref('about')} onClick={() => setMenuOpen(false)}>About</a>
            <a href={sectionHref('capabilities')} onClick={() => setMenuOpen(false)}>Capabilities</a>
            <a href={sectionHref('how-it-works')} onClick={() => setMenuOpen(false)}>How It Works</a>
            <a href={sectionHref('case-studies')} onClick={() => setMenuOpen(false)}>Case Studies</a>
            <a href={sectionHref('contact')} className="btn btn-nav" onClick={() => goToContact('contact')}>
              Contact Us
            </a>
          </nav>
        </div>
      </header>

      {onPrivacyPage ? (
        <PrivacyPolicy />
      ) : (
        <>
        {/* Hero Section */}
        <section className="hero" id="hero">
          <div className="video-background">
            <video autoPlay muted loop playsInline>
              <source src={videoBg} type="video/mp4" />
            </video>
            <div className="video-overlay" />
          </div>
          <div className="container hero-content">
            <span className="hero-badge">Urban Governance Copilot</span>
            <h1>
              Smarter Cities,<br />
              <span className="hero-accent">Better Governance</span>
            </h1>
            <p>
              Chitragupta empowers government bodies with AI-driven intelligence
               turning sensor data into decisive action across traffic, taxation,
              infrastructure, environment, and more.
            </p>
            <div className="hero-cta-group">
              <a href="#contact" className="btn btn-primary" onClick={() => goToContact('contact')}>Contact Us</a>
              <a href="#capabilities" className="btn btn-outline">Explore Capabilities</a>
            </div>
          </div>
          <a href="#about" className="scroll-indicator" aria-label="Scroll down">
            <span className="scroll-arrow">↓</span>
          </a>
        </section>

        {/* About Section */}
        <section className="about" id="about">
          <div className="container about-grid">
            <div className="about-text">
              <span className="section-label">About Chitragupta</span>
              <h2>One Platform.<br />Every Urban Challenge.</h2>
              <p>
                Chitragupta is a planetary-scale sensory data platform built for
                urban governance. We observe cities through vision and
                other sensors and transform that data into insights that help
                government bodies manage their functions more efficiently,
                transparently, and proactively.
              </p>
              <p>
                From detecting tax deviations to managing road infrastructure and
                monitoring environmental health, our copilot delivers the right
                intelligence to the right official at the right time.
              </p>
              <a href="#capabilities" className="btn btn-primary">See All Capabilities</a>
            </div>
            <div className="about-stats">
              <div className="stat-card">
                <span className="stat-number">8+</span>
                <span className="stat-label">Urban Use Cases</span>
              </div>
              <div className="stat-card">
                <span className="stat-number">Last-Mile</span>
                <span className="stat-label">Governance</span>
              </div>
              <div className="stat-card">
                <span className="stat-number">AI-First</span>
                <span className="stat-label">Decision Support</span>
              </div>
              <div className="stat-card">
                <span className="stat-number">Scalable</span>
                <span className="stat-label">City-Wide Deployment</span>
              </div>
            </div>
          </div>
        </section>

        {/* Capabilities Section */}
        <section className="capabilities" id="capabilities">
          <div className="container">
            <span className="section-label">Platform Capabilities</span>
            <h2 className="section-title">Everything Your City Needs</h2>
            <p className="section-subtitle">
              Our copilot platform covers the full spectrum of urban governance
              functions — all powered by the same sensory data infrastructure.
            </p>
            <div className="capabilities-grid">
              {capabilities.map((cap) => (
                <div className="capability-card" key={cap.title}>
                  <div className="capability-icon">{cap.icon}</div>
                  <h3>{cap.title}</h3>
                  <p>{cap.description}</p>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* How It Works Section */}
        <section className="how-it-works" id="how-it-works">
          <div className="container">
            <span className="section-label">Our Process</span>
            <h2 className="section-title">How Chitragupta Works</h2>
            <p className="section-subtitle">
              A simple three-step loop that continuously improves urban governance
              outcomes.
            </p>
            <div className="steps-grid">
              {steps.map((step, idx) => (
                <div className="step-card" key={step.number}>
                  <div className="step-number">{step.number}</div>
                  <h3>{step.title}</h3>
                  <p>{step.description}</p>
                  {idx < steps.length - 1 && (
                    <span className="step-arrow" aria-hidden="true">→</span>
                  )}
                </div>
              ))}
            </div>
          </div>
        </section>

        <section className="case-studies" id="case-studies">
          <div className="container case-studies-inner">
            <span className="section-label">Case Studies</span>
            <h2 className="section-title">See Chitragupta in Action</h2>
            <p className="section-subtitle">
              Explore how cities are using last-mile data to strengthen governance.
              Share your details and we'll send you relevant case studies.
            </p>
            <a href="#contact" className="btn btn-primary" onClick={() => goToContact('case-studies')}>
              Request Case Studies
            </a>
          </div>
        </section>

        {/* Waitlist / CTA Section */}
        <section className="signup" id="contact">
          <div className="container signup-inner">
            {/* <span className="section-label">Early Access</span> */}
            <span className="section-label">Contact Us</span>
            <h2>Let's Transform Your City Together</h2>
            <p>
              Get in touch and our team will reach out to discuss a pilot for
              your municipality.
            </p>
            <form className="signup-form" onSubmit={handleSubmit}>
              <input type="hidden" name="source" value={source} />
              <input type="text" name="name" placeholder="Name" required />
              <input type="text" name="organisation" placeholder="Organisation / City" required />
              <input type="text" name="role" placeholder="Role" required />
              <input type="email" name="email" placeholder="Email" required />
              <textarea name="message" placeholder="Message" rows="4" className="full-width" />
              <button type="submit" className="btn btn-primary" disabled={status === 'sending'}>
                {status === 'sending' ? 'Sending...' : 'Contact Us'}
              </button>
              {status === 'success' && (
                <p className="form-status form-success">Thanks! We'll be in touch soon.</p>
              )}
              {status === 'error' && (
                <p className="form-status form-error">Something went wrong. Please try again.</p>
              )}
              <p className="form-note">
                By submitting this form, you agree to our{' '}
                <a href={PRIVACY_PATH}>Privacy Policy</a>.
              </p>
            </form>
          </div>
        </section>
        </>
      )}

      {/* Footer */}
      <footer>
        <div className="container footer-inner">
          <div className="footer-brand">
            <CGLogo className="logo-icon" />
            <span className="logo">Chitragupta</span>
            <p>Urban Governance Copilot Platform</p>
          </div>
          <div className="footer-links">
            <a href={sectionHref('about')}>About</a>
            <a href={sectionHref('capabilities')}>Capabilities</a>
            <a href={sectionHref('how-it-works')}>How It Works</a>
            <a href={sectionHref('case-studies')}>Case Studies</a>
            <a href={sectionHref('contact')} onClick={() => goToContact('contact')}>Contact Us</a>
          </div>
          <div className="footer-socials">
            <h4 className="footer-heading">Social</h4>
            {socials.map((s) => (
              <a key={s.href} href={s.href} target="_blank" rel="noopener noreferrer">
                {s.label}
              </a>
            ))}
          </div>
        </div>
        <div className="footer-bottom">
          <p>
            &copy; 2024 Chitragupta.co — All rights reserved.
            <span className="footer-divider" aria-hidden="true">|</span>
            <a href={PRIVACY_PATH}>Privacy Policy</a>
          </p>
        </div>
      </footer>
    </div>
  );
}

export default App;